import ResetPassword from '@/components/resetPassword';
import { Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
const { Title } = Typography;

const Forgot: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('common');
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-[#1E1E1E]">
            <div className="w-full max-w-md bg-white dark:bg-[#252526] p-8 rounded-lg shadow-md">
                <Title level={3} className="text-center mb-4">
                    {t('forgot.title')}
                </Title>
                <ResetPassword open={true} dialog={false} onClose={() => {
                    navigate('/');
                }} />
            </div>
        </div >
    );
};

export default Forgot;